import React from "react";
import BiovicaLogo from "../../assets/biovica-logo.png";
import "./styles/ConstantSection.css";

const ConstantSection: React.FC = () => {
  const getGeneralInfos = () => {
    return (
      <ul className="list-preview left-list">
        <li>DiviTum®TKa is a multi-step end-point ELISA assay that measures thymidine kinase activity (TKa) in human serum.</li>
        <li>TK activity is an indicator for cell proliferation.</li>
        <li>The clinical reference value of 250 DuA is based on the 95th percentile of the distribution of TKa levels in a healthy population reference study<sup>1,3</sup>.</li>
        <li>This clinical reference value/cut-off has been verified clinically to correlate with the risk of disease progression in patients with hormone receptor positive breast cancer<sup>2-10</sup>.</li>
        <li>For patients prescribed a CDK4/6 inhibitor, on-therapy TKa reference values of 100 DuA and 50 DuA have been further validated to correlate with patient outcome<sup>8,10</sup>.</li>
      </ul>
    )
  }
  const getDisclaimerList = () => {
    return (
      <ul className="list-preview">
        <li>DiviTum TKa results should be used in conjunction with other clinical methods for monitoring breast cancer.</li>
        <li>Decisions on patient care must be based on the independent medical judgement of the treating physician, taking into consideration all available information concerning the patient’s condition and in accordance with applicable standard of care.</li>
        <li>For complete DiviTum Tka test information including limitations, see DiviTum website: https://divitum.com/about-the-test/</li>
      </ul>
    )
  }

  return (
    <div className="constant-section dashboard-constant-section">
      <div className="general-test-information">
        <div className="general-info-limitations">
          <div className="warnings">
            <div className="common-header">General test information<span className='semicolon1'>:</span></div>
            {getGeneralInfos()}
            <div className="extra-test-info">
              <div className="info-item">
                <div className="icon-circle">‡</div>
                <p>
                  <span>{`Patients treated with CDK4/6i in whom TKa values remain <100 DuA, or in whom sustained suppression is seen, are likely to have PFS exceeding 2 years.`}</span>
                  <span><sup>8</sup></span>
                </p>
                
              </div>
              <div className="info-item">
                <div className="icon-circle">‡</div>
                <p>
                  <span>{`Failure to suppress TKa to <100 DuA identifies patients with poor disease response to CDK4/6i who may benefit from additional or alternate therapies and enhanced
imaging monitoring.`}</span>
                  <span><sup>8</sup></span>
                </p>
                
              </div>
            </div>
          </div>
          <div className="limitations">
            <div className="common-header">Disclaimer<span className='semicolon2'>:</span></div>
            {getDisclaimerList()}
          </div>
        </div>
        <div className="reference-section">
          <div>
            <strong className="reference reference-title">References:</strong>
          </div>
          <div>
            <strong className="reference">1. </strong>
            DiviTum®TKa FDA 501K Clearance: https://www.accessdata.fda.gov/cdrh_docs/pdf20/K202852.pdf
            <strong className="reference"> 2. </strong>
            Paoletti C, Barlow WE, Cobain EF, et al. Evaluating Serum Thymidine Kinase 1 in Patients with Hormone
            Receptor-Positive Metastatic Breast Cancer Receiving First-line Endocrine Therapy in the SWOG S0226 Trial. Clin Cancer Res. 2021; 27(22):6115-6123.
            <strong className="reference"> 3. </strong>
            Bergqvist M, et al. Thymidine kinase activity levels in
            serum can identify HR+ metastatic breast cancer patients with a low risk of early progression (SWOG S0226). Biomarkers. 2023; 29:1-10.
            <strong className="reference"> 4. </strong>
            Malorni L, Tyekucheva S, Hilbers FS, et al. Serum thymidine kinase
            activity in patients with hormone receptor-positive and HER2-negative metastatic breast cancer treated with palbociclib and fulvestrant. Eur J Cancer. 2022;164:39-51.
            <strong className="reference"> 5. </strong>
            Malorni L, Bianchini G, Caputo R, et al.
            Serum thymidine kinase activity in patients with HRpositive/HER2-negative advanced breast cancer treated with ribociclib plus letrozole: Results from the prospective BioItaLEE trial. Eur J Cancer. 2023; 186: 1–11.
            <strong className="reference"> 6. </strong>
            Krishnamurthy J, Luo J, Suresh R, et al. A phase II trial of an alternative schedule of palbociclib and embedded serum TK1 analysis. NPJ Breast Cancer. 2022;8(1):35.
            <strong className="reference"> 7. </strong>
            Albanell J, Williams A, Martínez MT, et al.
            “Use of liquid biomarker thymidine kinase activity (TKa) to predict outcome and progression in patients with metastatic breast cancer (MBC) in the GEICAM/2014-12 FLIPPER trial” ASCO Annual Meeting 2024, J
            Clin Oncol 42, 2024 (suppl 16; abstr 1028)
            <strong className="reference"> 8. </strong>
            Howell S, Bergqvist M, Williams A, et al. “Thymidine kinase activity as a prognostic biomarker for first line CDK4/6 inhibitor efficacy in the Personalised Disease
            Monitoring in Metastatic Breast Cancer (PDM-MBC) study” San Antonio Breast Cancer Symposium 2024, Poster P5-02-16.
            <strong className="reference"> 9. </strong>
            Williams A, Bear H, Denkert C, et al. “Evaluation of proliferation biomarker serum
            thymidine kinase activity and prediction of early relapse in HR positive HER2 negative high risk early breast cancer: Analysis from the PENELOPE-B trial” San Antonio Breast Cancer Symposium 2024, Poster
            P1-09-06.
            <strong className="reference"> 10. </strong>
            Witkiewicz A, Schultz S, Knudsen ES et al. “Interrogating serum thymidine kinase activity with CDK4/6 inhibitor based therapies: real-world experience in the metastatic and adjuvant setting” San
            Antonio Breast Cancer Symposium 2024, Poster P2-05-16.
          </div>
        </div>
        <div className="divider"></div>
        <div className="footer">
          <div className="footer-left">
            <div className="left-footer-text">
              DiviTum<sup>®</sup> TKa has been cleared by the US FDA. Biovica is certified under CLIA to perform high complexity
              clinical laboratory testing.
            </div>
            <div className="left-footer-copyright">
              <div>The test may be covered by one or more US pending or issued patents—see <a href="https://www.biovica.com/">www.biovica.com</a> for details.</div>
            </div>
            <div className="left-footer-copyright">
              DiviTum<sup>®</sup> is a registered trademark of Biovica International AB. ©2023 Biovica, Inc<span className="pdf-ml--1-5px pdf-mr-2px">. </span> All rights reserved. PN: 1026. May 2025

            </div>
          </div>
          <div className="footer-right">
            <div className="biovica-logo">
              <img src={BiovicaLogo} alt="Biovica Logo"></img>
            </div>
            <div className="biovica-desc">
              <div className="address">
                <div>6195 Cornerstone Court E, Suite 101</div>
                <div> San Diego, CA 92121</div>
              </div>
              {/* <div className="telephone">
                <div>Main line: 858-230-6164</div>
              </div> */}
              <div className="tel-and-link">
                <a href="tel:+1-858-230-6164" className="biovica-web-link">+1-858-230-6164</a>
                <a href="https://biovica.com/" className="biovica-web-link">
                  www.biovica.com
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ConstantSection;
